import { render } from "./SlaughterSheets.vue?vue&type=template&id=45511e5b&scoped=true"
import script from "./SlaughterSheets.vue?vue&type=script&lang=js"
export * from "./SlaughterSheets.vue?vue&type=script&lang=js"

import "./SlaughterSheets.vue?vue&type=style&index=0&id=45511e5b&lang=css"
import "./SlaughterSheets.vue?vue&type=style&index=1&id=45511e5b&scoped=true&lang=css"
import "./SlaughterSheets.vue?vue&type=style&index=2&id=45511e5b&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45511e5b"]])

export default __exports__